import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import SolicitacoesPendentes from './components/SolicitacoesPendentes';
import ContasServicoLista from './components/ContasServicoLista';
import PerfisContaServico from './components/PerfisContaServico';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import HelpDrawerContaServico from './HelpDrawerContaServico';
import { BsQuestionCircle } from 'react-icons/bs';

const ContaServicoPage: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const [activeTab, setActiveTab] = useState('solicitacoes');
  const [showHelpDrawer, setShowHelpDrawer] = useState(false);
  
  useEffect(() => {
    setBreadcrumbs([
      { path: '/', breadcrumb: '🏠' },
      { path: '/contas-servico', breadcrumb: 'Conta de Serviço' },
    ]);
  }, []);

  return (
    <HelpDrawerContaServico isOpen={showHelpDrawer} onClose={() => setShowHelpDrawer(false)}>
    <div className="container mt-4">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Gerenciamento de Contas de Serviço</h2>
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => setShowHelpDrawer(true)}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}
        >
          <BsQuestionCircle /> Ajuda
        </button>
      </div>
      <hr />
      
      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'solicitacoes')}>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="solicitacoes">Solicitações Pendentes</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="contas">Contas de Serviço</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="perfis">Perfis de Conta de Serviço</Nav.Link>
          </Nav.Item>
        </Nav>
        
        <Tab.Content>
          <Tab.Pane eventKey="solicitacoes">
            <SolicitacoesPendentes />
          </Tab.Pane>
          <Tab.Pane eventKey="contas">
            <ContasServicoLista />
          </Tab.Pane>
          <Tab.Pane eventKey="perfis">
            <PerfisContaServico />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
    </HelpDrawerContaServico>
  );
};

export default ContaServicoPage;
